import PrevisionList from "./prevision-list/PrevisionList";
import MapCard from "./map-card/MapCard";
import ButtonContainer from "@/components/button-container/ButtonContainer";
import chevron from "@/img/chevron-right.svg";

import { useTranslation } from "react-i18next";
import { Button } from "@wordpress/components";

import "./style.scss";

export const App = () => {
	const { t } = useTranslation();

	return (
		<div className="map-with-previsition">
			<MapCard />
			<PrevisionList />
			<ButtonContainer
				href="/weather-map"
				content={
					<Button>
						{t("viewMap")}
						<img src={chevron} alt="arrow" />
					</Button>
				}
			/>
		</div>
	);
};

export default App;
